import PMHeadshot from '../images/about/exec-profiles/UWPMHeadshot.png';
import Muktha from '../images/about/exec-profiles/Muktha2.jpg';
import Khushi from '../images/about/exec-profiles/Khushi.JPG';
import EvelynT from '../images/about/exec-profiles/Evelyn.jpg';
import Orlando from '../images/about/exec-profiles/Orlando.jpeg';
import August from '../images/about/exec-profiles/August.jpg';
import Samir from '../images/about/exec-profiles/Samir.JPG';
import Milind from '../images/about/exec-profiles/Milind.png';
import Ria from '../images/about/exec-profiles/UWPMHeadshot.png';
import Aishwarya from '../images/about/exec-profiles/Aishwarya2.jpg';
import Kaelen from '../images/about/exec-profiles/Kaelen.jpeg';
import Vivan from '../images/about/exec-profiles/Vivan.JPG';
import Samin from '../images/about/exec-profiles/Samin.jpeg';
import Michelle from '../images/about/exec-profiles/Michelle.jpeg';
import Bianca from '../images/about/exec-profiles/Bianca.PNG';
import Aditi from '../images/about/exec-profiles/Aditi.jpeg';
import Iris from '../images/about/exec-profiles/Iris.jpg';
import Nicole from '../images/about/exec-profiles/Nicole.jpg';
import Masudah from '../images/about/exec-profiles/Masudah.png';
import Michael from '../images/about/exec-profiles/Michael.jpg';
import Danny from '../images/about/exec-profiles/danny.jpg';
import Yash from '../images/about/exec-profiles/Yash.jpeg';
import Owen from '../images/about/exec-profiles/Owen.jpg';
import Gaurika from '../images/about/exec-profiles/Gaurika.jpeg';
import Jiya from '../images/about/exec-profiles/Jiya.JPG';
import Arpit from '../images/about/exec-profiles/UWPMHeadshot.png';
import Puneet from '../images/about/exec-profiles/Puneet.jpg';
import Fanelle from '../images/about/exec-profiles/Fanelle.jpeg';
import Maurya from '../images/about/exec-profiles/Maurya.jpeg';
import EvelynW from '../images/about/exec-profiles/Evelyn.jpeg';
import Evan from '../images/about/exec-profiles/Evan.jpeg';
import Ellie from '../images/about/exec-profiles/Ellie.jpeg';
import Nemesha from '../images/about/exec-profiles/Nemesha.jpeg';
import Cedric from '../images/about/exec-profiles/Cedric.png';
import Krish from '../images/about/exec-profiles/Krish.jpg';
import Lalithya from '../images/about/exec-profiles/Lalithya.jpg';
import Naysha from '../images/about/exec-profiles/Naysha.jpeg';
import Shreya from '../images/about/exec-profiles/Shreya.jpeg';
import Samuel from '../images/about/exec-profiles/Samuel.jpg';
import KrishFinance from '../images/about/exec-profiles/Krish.jpg';

export const ExecList = {
  Muktha: {
    name: 'Muktha Kaja',
    role: 'Co President',
    link: 'https://www.linkedin.com/in/muktha-kaja-9a2803248/',
    image: Muktha,
  },
  Khushi: {
    name: 'Khushi Adukia',
    role: 'VP Marketing',
    link: 'https://www.linkedin.com/in/khushiadukia',
    image: Khushi,
  },
  EvelynT: {
    name: 'Evelyn Thomas',
    role: 'Marketing Director',
    link: 'https://www.linkedin.com/in/evelyn-thomas-et100/',
    image: EvelynT,
  },
  Orlando: {
    name: 'Orlando Zhou',
    role: 'Marketing Director',
    link: 'https://www.linkedin.com/in/orlando-zhou/',
    image: Orlando,
  },
  August: {
    name: 'August Tan',
    role: 'VP Podcast',
    link: 'https://www.linkedin.com/in/august-tan/',
    image: August,
  },
  Samir: {
    name: 'Samir Sarwar',
    role: 'Podcast Director',
    link: 'https://www.linkedin.com/in/samir-sarwar-pm/',
    image: Samir,
  },
  Milind: {
    name: 'Milind Kumar',
    role: 'Podcast Director',
    link: 'https://www.linkedin.com/in/milind-kumar-7228191b7/',
    image: Milind,
  },
  Ria: {
    name: 'Ria Pradhan',
    role: 'Podcast Director',
    link: 'https://www.linkedin.com/in/riapradh/',
    image: Ria,
  },
  Aishwarya: {
    name: 'Aishwarya Tandon',
    role: 'Co President',
    link: 'https://www.linkedin.com/in/aishwarya-tandon-028776273',
    image: Aishwarya,
  },
  Kaelen: {
    name: 'Kaelen Davis',
    role: 'Outreach Director',
    link: 'https://www.linkedin.com/in/kaelen-davis/',
    image: Kaelen,
  },
  Vivan: {
    name: 'Vivan Yang',
    role: 'Outreach Director',
    link: 'https://www.linkedin.com/in/vivian-yyang1/',
    image: Vivan,
  },
  Samin: {
    name: 'Samin Koleini',
    role: 'Outreach Director',
    link: 'https://www.linkedin.com/in/samin-koleini/',
    image: Samin,
  },
  Michelle: {
    name: 'Michelle Wang',
    role: 'VP Design',
    link: 'https://www.linkedin.com/in/michelle-wng',
    image: Michelle,
  },
  Bianca: {
    name: 'Bianca Batiao',
    role: 'Design Director',
    link: '',
    image: Bianca,
  },
  Aditi: {
    name: 'Aditi Suresh',
    role: 'Design Director',
    link: 'https://linkedin.com/in/aditi-suresh-0b4673239',
    image: Aditi,
  },
  Iris: {
    name: 'Iris Zhu',
    role: 'Design Director',
    link: 'https://www.linkedin.com/in/irisz06/',
    image: Iris,
  },
  Nicole: {
    name: 'Nicole Tang',
    role: 'VP Events',
    link: '',
    image: Nicole,
  },
  Masudah: {
    name: 'Masudah Haque',
    role: 'Events Director',
    link: '',
    image: Masudah,
  },
  Michael: {
    name: 'Michael Pasyechnyk',
    role: 'Events Director',
    link: '',
    image: Michael,
  },
  Danny: {
    name: 'Danny Liang',
    role: 'VP Engineering',
    link: 'https://www.linkedin.com/in/danny-liang-dl/',
    image: Danny,
  },
  Yash: {
    name: 'Yash H. Barve',
    role: 'Developer',
    link: 'https://www.linkedin.com/in/yhbarve/',
    image: Yash,
  },
  Owen: {
    name: 'Owen Li',
    role: 'Events Director',
    link: 'https://www.linkedin.com/in/owen-li-waterloo/',
    image: Owen,
  },
  Gaurika: {
    name: 'Gaurika Gupta',
    role: 'Engineering Director',
    link: 'https://www.linkedin.com/in/gaurikagupta1/',
    image: Gaurika,
  },
  Shreya: {
    name: 'Shreya Sharma',
    role: 'VP Engineering',
    link: 'https://www.linkedin.com/in/shreya-sharma-821826321/',
    image: Shreya,
  },
  Krish: {
    name: 'Krish Suryavanshi',
    role: 'Engineering Director',
    link: 'https://www.linkedin.com/in/krish-suryavanshi/',
    image: Krish,
  },
  Cedric: {
    name: 'Cedric Leung',
    role: 'Engineering Director',
    link: 'https://www.linkedin.com/in/cedric-leungg/',
    image: Cedric,
  },
  Lalithya: {
    name: 'Lalithya Raavi',
    role: 'Engineering Director',
    link: 'https://www.linkedin.com/in/lalithyaraavi/',
    image: Lalithya,
  },
  Naysha: {
    name: 'Naysha Gakhar',
    role: 'Engineering Director',
    link: 'https://www.linkedin.com/in/naysha-gakhar/',
    image: Naysha,
  },
  Jiya: {
    name: 'Jiya Anadkat',
    role: 'VP Content',
    link: 'https://www.linkedin.com/in/jiya-anadkat/',
    image: Jiya,
  },
  Arpit: {
    name: 'Arpit Arun Kumaar',
    role: 'Content Director',
    link: 'https://www.linkedin.com/in/arpitarunkumaar/',
    image: Arpit,
  },
  Puneet: {
    name: 'Puneet Bhullar',
    role: 'Content Director',
    link: 'https://www.linkedin.com/in/puneetbhullar/',
    image: Puneet,
  },
  Fanelle: {
    name: 'Fanelle Pang',
    role: 'VP Outreach',
    link: 'https://www.linkedin.com/in/fanelle-pang/',
    image: Fanelle,
  },
  Maurya: {
    name: 'Maurya Patel',
    role: 'Outreach Director ',
    link: 'https://www.linkedin.com/in/maurya-patel-2ab8b0234/',
    image: Maurya,
  },
  EvelynW: {
    name: 'Evelyn Wang',
    role: 'Outreach Director',
    link: '',
    image: EvelynW,
  },
  Evan: {
    name: 'Evan Liem',
    role: 'Design Director',
    link: 'linkedin.com/in/evan-liem-178443340/?skipRedirect=true',
    image: Evan,
  },
  Ellie: {
    name: 'Ellie Chan',
    role: 'VP Design',
    link: 'https://www.linkedin.com/in/elliechan25/',
    image: Ellie,
  },
  Nemesha: {
    name: 'Nemesha De Silva',
    role: 'Design Director',
    link: 'https://www.linkedin.com/in/nemeshadesilva/',
    image: Nemesha,
  },
  Samuel: {
    name: 'Samuel Huang',
    role: 'Co President',
    link: 'https://www.linkedin.com/in/samuelzh/',
    image: Samuel,
  },
  KrishFinance: {
    name: 'Krish Suryavanshi',
    role: 'VP Finance',
    link: 'https://www.linkedin.com/in/krish-suryavanshi/',
    image: KrishFinance,
  },
};
